// ============================================================================
// KOREAN TRANSLATIONS - UI (한국어)
// ============================================================================

import unityTranslations from './unity.js';
export const uiTranslations = {
  meta: {
    language: 'ko',
    languageName: '한국어',
    version: '1.0'
  },
  
  app: {
    title: "UNITYQUEST 사랑의\n연대기",
    subtitle: "대화형 성경 탐구",
    tagline: "신성한 빛을 향해",
    menu: "메뉴",
    retry: "다시 시도"
  },
  
  buttons: {
    play: "플레이",
    back: "뒤로",
    continue: "계속",
    restart: "다시 시작",
    close: "닫기",
    nextLevel: "다음 레벨",
    selectLevel: "레벨 선택",
    retry: "재시도",
    mainMenu: "메인 메뉴",
    start: "시작",
    cancel: "취소",
    confirm: "확인",
    save: "저장",
    load: "불러오기",
    yesRestart: "예, 다시 시작",
    noContinue: "아니요, 계속",
    tryAgain: "다시 시도",
    backToMenu: "메뉴로 돌아가기"
  },
  
  labels: {
    score: "점수",
    stars: "별",
    wisdom: "지혜",
    revelation: "계시",
    lives: "생명",
    combo: "콤보",
    level: "레벨",
    easy: "쉬움",
    medium: "보통",
    hard: "어려움",
    correct: "정답!",
    gameOver: "시련 실패",
    victory: "승리!",
    completed: "완료",
    rank: "영적 등급",
    points: "지혜 포인트",
    unlockedLevels: "잠금 해제된 레벨",
    questionOfKnowledge: "지식의 질문",
    hintOfWisdom: "지혜의 힌트",
    knowledgeMastered: "지식 완전 습득!",
    knowledgeAcquired: "지식 획득!",
    testFailed: "시련 실패",
    wisdomBonus: "보너스"
  },
  
  menu: {
    playButton: "플레이",
    info: "정보",
    treasures: "보물",
    john: "요한",
    reset: "초기화",
    resetConfirm: "모험을 다시 시작하시겠습니까?",
    resetWarning: "모든 진행 상황을 삭제하시겠습니까?",
    resetLose: "잃게 될 것:",
    wisdomPoints: "지혜 포인트",
    starsCollected: "수집한 별",
    levelsUnlocked: "잠금 해제된 레벨",
    spiritualRank: "영적 계급",
    yesRestart: "예, 다시 시작",
    noContinue: "아니요, 계속",
    newAdventure: "새로운 모험",
    readyToStart: "시작할 준비가 되셨습니까?",
    startJourney: "성경 지식의 여정을 시작하세요!",
    audioControls: "오디오 제어",
    mute: "음소거",
    unmute: "음소거 해제",
    close: "닫기",
    language: "언어",
    restartGame: "게임 재시작"
  },
  
  login: {
    title: "UNITY QUEST",
    subtitle: "인터랙티브 성경 모험",
    anonymousMode: "익명으로 플레이",
    anonymousDesc: "닉네임 선택",
    emailMode: "이메일 로그인",
    emailDesc: "다중 기기 저장",
    pseudo: "닉네임",
    pseudoPlaceholder: "당신의 닉네임...",
    email: "이메일 주소",
    emailPlaceholder: "your@email.com",
    startPlaying: "게임 시작",
    sendLink: "링크 보내기",
    sending: "전송 중...",
    connecting: "연결 중...",
    back: "뒤로",
    localSave: "진행 상황이 로컬에 저장됩니다",
    cloudSync: "비밀번호 불필요 • 클라우드 동기화",
    magicLink: "이메일로 매직 링크 받기",
    checkEmail: "✉️ 이메일을 확인하세요! 로그인 링크가 전송되었습니다.",
    checkSpam: "스팸 폴더도 확인하세요",
    waitingConnection: "연결 대기 중...",
    errorSend: "링크 전송 오류",
    rateLimited: "⏳ 이메일을 다시 보내기 전에 15초 기다려주세요",
    importSession: "🔄 프로덕션에서 세션 가져오기",
    errorConnection: "연결 오류",
    enterPseudo: "닉네임을 입력하세요",
    enterEmail: "유효한 이메일을 입력하세요",
    // Tooltips
    never: "없음",
    save: "게임 저장",
    lastSave: "마지막",
    refresh: "진행 상황 다시 로드",
    logout: "로그아웃",
    connectToCloud: "온라인 저장을 위해 연결",
    editPseudo: "사용자 이름 편집",
    confirm: "확인",
    cancel: "취소",
    close: "닫기",
    passwordMode: "간단 로그인",
    passwordDesc: "이메일 + 비밀번호",
    password: "비밀번호",
    passwordPlaceholder: "최소 6자",
    passwordMinLength: "최소 6자",
    playWithoutAccount: "계정 없이 플레이",
    forgotPassword: "비밀번호를 잊으셨나요?",
    resetPasswordTitle: "비밀번호 재설정",
    resetPasswordSubtitle: "재설정 링크를 받으려면 이메일을 입력하세요",
    sendResetLink: "링크 보내기",
    resetEmailSent: "📧 재설정 이메일이 전송되었습니다! 받은편지함을 확인하세요.",
    errorReset: "이메일 전송 오류",
    backToSignin: "로그인으로 돌아가기",
    newPassword: "새 비밀번호",
    enterNewPassword: "새로운 안전한 비밀번호를 선택하세요",
    confirmPassword: "비밀번호 확인",
    updatePassword: "비밀번호 업데이트",
    passwordsDontMatch: "비밀번호가 일치하지 않습니다",
    passwordUpdateSuccess: "✅ 비밀번호가 성공적으로 업데이트되었습니다!",
    errorUpdatePassword: "비밀번호 업데이트 중 오류 발생",
    resetLinkExpired: "재설정 링크가 만료되었거나 유효하지 않습니다",
    forgotPassword: "비밀번호를 잊으셨나요?",
    signup: "가입",
    signin: "로그인",
    createAccount: "계정 만들기",
    signupInfo: "아래 양식을 작성하세요",
    passwordInfo: "비밀번호로 빠른 액세스",
    signupButton: "내 계정 만들기",
    signinButton: "로그인",
    passwordTooShort: "비밀번호는 최소 6자 이상이어야 합니다",
    emailAlreadyExists: "이 이메일은 이미 사용 중입니다",
    emailExistsHint: "✉️ 이 이메일은 이미 등록되어 있습니다. 로그인을 시도하세요! (다른 게임에서 만들었을 수도 있습니다)",
    switchToSignin: "🔑 기존 이메일로 로그인 모드로 전환하세요",
    invalidCredentials: "이메일 또는 비밀번호가 잘못되었습니다",
    signupSuccess: "📧 계정이 생성되었습니다! 등록을 확인하기 위해 이메일을 확인하세요.",
    emailConfirmationRequired: "계정을 활성화하기 위해 받은편지함을 확인하세요",
    checkSpamFolder: "스팸 폴더를 확인하는 것을 잊지 마세요",
    connectionSuccess: "✅ 로그인 성공!",
    errorSignup: "가입 중 오류 발생"},
  
  install: {
    title: "앱 설치",
    subtitle: "빠른 액세스 및 오프라인",
    feature1: "홈 화면에서 즉시 실행",
    feature2: "설치 후 오프라인 작동",
    feature3: "네이티브 앱 경험",
    feature4: "스토어 다운로드 불필요",
    install: "설치",
    dismiss: "나중에",
    info: "언제든지 앱을 제거할 수 있습니다"
  },
  
  ranks: {
    seeker: "구도자",
    believer: "각성자",
    disciple: "제자",
    servant: "종",
    witness: "증인",
    guardian: "수호자",
    wise: "현자",
    prophet: "예언자",
    apostle: "사도",
    seekerDesc: "영적 여정의 시작",
    believerDesc: "깨어난 영적 의식",
    discipleDesc: "가르침 배우기",
    servantDesc: "봉사와 헌신",
    witnessDesc: "믿음 나누기",
    guardianDesc: "진리 보호",
    wiseDesc: "지혜와 지식",
    prophetDesc: "영적 비전",
    apostleDesc: "영적 스승"
  },

  spiritualJourney: {
    beginning: "영적 여정의 시작",
    progress: "영적 진보",
    grade: "등급",
    xp: "XP",
    level: "레벨",
    nextGrade: "다음 등급",
    still: "아직",
    maxLevelReached: "최고 레벨에 도달했습니다!",
    masteredAllTeachings: "모든 가르침을 마스터했습니다",
    progression: "진행"
  },
  
  treasures: {
    title: "💎 성경 보물",
    verse: "오늘의 말씀",
    fact: "알고 계셨나요?",
    treasure: "숨겨진 보물",
    question: "재미있는 질문",
    context: "맥락",
    strongReference: "심층 연구를 위한 성경 참조",
    verseOfDay: "✨ 오늘의 말씀",
    didYouKnow: "🌟 알고 계셨나요?",
    hiddenTreasure: "📜 숨겨진 보물",
    funnyQuestion: "🤔 재미있는 질문",
    emmanuelMemo: "엠마누엘의 메모",
    emmanuelMessage: "당신은 산 정상에 도달했고 지식을 얻었습니다. 그러나 흔들리지 않는 믿음은 삶의 경험, 자비, 그리고 예수님에 대한 진정한 사랑이 필요합니다. 삶의 다양한 시련은 당신의 길, 우리가 선택하는 진정한 길, 우리의 마음을 시험할 것입니다. 우리는 불완전하고 욕망이 많으며, 이익이나 개인적인 편안함에 대한 사랑이 너무 자주 우리의 이기적인 우선순위가 됩니다. 하나님께 지혜, 그분의 사랑, 그분의 힘을 구하고 겸손하게 당신의 약점을 인정하십시오. 왜냐하면 그분께 숨길 수 있는 것은 아무것도 없기 때문입니다... 아무것도. 개인 모드로 여행하거나 VPN을 사용하거나 기록을 삭제할 필요가 없습니다. 다니엘처럼 금식하십시오: 평온함과 지혜 속에서 당신이 가장 사랑하는 것을 잠시 박탈하십시오. 이것은 당신이 하나님을 더 잘 듣고, 깊은 - 그리고 종종 고통스러운 - 변화에 준비된 마음의 성향을 갖도록 할 것입니다. 그러면 요셉처럼 꿈과 환상이 더 명확해질 것입니다. 그러나 교만을 경계하십시오: '나는 항상 옳다' 또는 '나는 더 잘 안다'에 굴복하지 마십시오. 왜냐하면 하나님의 계시는 특별한 은혜이기 때문입니다. 오늘날 예수님을 다시 십자가에 못 박을 수 있는 율법 교사가 되지 마십시오. 그분은 단순히 이웃을 사랑하고... 당신이 받는 것과 같은 자유를 그들에게 부여하라고 요청합니다. 믿음을 갖는다는 것은 자유로운 관계와 마음의 여정에 들어가는 것을 의미합니다. 그것은 당신을 불가능한 일을 할 수 있는 강력한 영웅으로 만들 것입니다. 왜냐하면 초자연적인 경험, 하나님의 임재, 그분의 확인 또는 축복이 당신을 진정으로 흔들리지 않게 만들 것이기 때문입니다.",
    jesusIsNot: "❌ 중요한 설명",
    clarification: "중요한 설명",
    bibleOffline: "오프라인 성경 읽기",
    bibleStudy: "성경 연구",
    version: "버전",
    openReader: "리더 열기",
    features: "기능"
  },
  
  messages: {
    chooseCard: "⚡ 파워 카드 선택",
    cardHelp: "이 레벨의 3개 질문에 함께합니다",
    chooseAnswer: "📖 답을 선택하세요:",
    wrongAnswer: "❌ 오답! 남은 생명은 {lives}개입니다. 다시 시도하세요!",
    levelCompleted: "레벨 {level} 완료",
    questionsProgress: "질문 {current}/3",
    starsCollected: "수집한 별: {current}/{total}",
    pointsEarned: "+{points} 지혜 포인트",
    secondChance: "🛡️ 용기 카드가 두 번째 기회를 줍니다! 지혜롭게 다시 시도하세요.",
    bonusApplied: "✨ {card} 보너스: +{percent}% ({base} → {final})",
    defeatedQuote: "내게 능력 주시는 자 안에서 모든 것을 할 수 있습니다",
    perfect: "✨ 완벽",
    good: "👍 좋음",
    start: "👍 시작",
    secretLevel: "🔓 비밀 레벨 잠금 해제!",
    secretChapter: "🌟 비밀 챕터",
    returnToLevels: "돌아가기",
    next: "다음",
    retry: "재시도",
    menu: "메뉴",
    chapter: "챕터",
    chapterStars: "챕터 별",
    totalGlobal: "전체 합계",
    backToMenu: "메뉴로 돌아가기"
  },
  
  bibleResources: {
    inAppReader: {
      name: "앱에서 읽기",
      description: "Strong과 통합된 성경 리더",
      features: {
        offline: "오프라인",
        strong: "Strong 번호",
        navigation: "탐색"
      }
    }
  },
  
  quotes: {
    wisdom: "여호와를 경외하는 것이 지혜의 근본",
    faith: "나를 강하게 하시는 이 안에서 내가 모든 것을 할 수 있다",
    hope: "여호와는 나의 목자시니 내게 부족함이 없으리로다",
    love: "하나님이 세상을 이처럼 사랑하사...",
    perseverance: "믿음은 인내가 필요합니다",
    defeat: "실패는 지식의 성장으로 초대합니다"
  },

  cards: {
    faith: "믿음",
    courage: "용기",
    wisdom: "지혜",
    faithKnowledge: "+50% 포인트",
    courageKnowledge: "두 번째 기회",
    wisdomKnowledge: "힌트 + 보너스",
    faithDesc: "획득한 최대 지혜 포인트",
    courageDesc: "일반 포인트지만 두 번째 기회",
    wisdomDesc: "힌트 공개 및 +25% 포인트",
    chooseCard: "✨ 지식 카드를 선택하세요",
    cardEffects: "✨ 지식 카드의 효과:",
    faithEffect: "+50% 지혜 포인트 - 최대 보상",
    courageEffect: "일반 포인트지만 오류 시 두 번째 기회",
    wisdomEffect: "+25% 포인트 + 각 질문마다 힌트 공개",
    chooseWisely: "현명하게 선택하세요, 당신의 선택이 레벨 전체에 동행합니다"
  },

  challenge: {
    loading: "레벨 로딩 중...",
    peace: "🕊️ 당신의 집에 평화가 깃들기를",
    questionsAwaiting: "🎯 3개의 지식 질문이 기다리고 있습니다",
    starsQuote: "각 별은 신성한 빛을 향한 한 걸음입니다"
  },

  info: {
    title: "Unity Quest 평화의 연대기",
    subtitle: "성경의 대화형 발견",
    yourStats: "당신의 통계",
    score: "점수",
    wisdom: "지혜",
    revelation: "계시",
    createdWith: "❤️로 만들어진",
    creator: "Emmanuel Payet",
    developerPassionate: "영성에 열정적인 개발자",
    artistModule: "엠마누엘 아티스트",
    artistPortfolio: "예술 포트폴리오 및 디지털 창작물",
    features: "기능",
    multipleChapters: "8개의 성경 챕터에 걸쳐 91개 레벨",
    powerCards: "3개의 고유한 파워 카드 (믿음, 용기, 지혜)",
    progressionSystem: "영적 순위가 있는 진행 시스템",
    bibleTreasures: "성경 보물과 흥미로운 사실",
    howToPlay: "플레이 방법",
    selectLevel: "잠금 해제된 레벨 선택",
    choosePowerCard: "파워 카드 선택",
    answerQuestions: "3개의 지식 질문에 답하기",
    earnStars: "남은 생명에 따라 별 획득",
    tips: "팁",
    readCarefully: "각 질문을 주의 깊게 읽으세요",
    useWisdomCard: "힌트를 위해 지혜 카드 사용",
    courageGivesSecondChance: "용기 카드는 두 번째 기회를 제공합니다",
    faithMaximizes: "믿음 카드는 포인트를 최대화합니다",
    johnGospelTitle: "요한복음",
    johnGospelStats: "21장 • 878절 • 14개 언어",
    bibleReaderStrong: "성경 리더 + Strong",
    bibleReaderStrongDesc: "Strong 사전과 함께하는 완전한 읽기",
    johnTreasures: "요한의 보물",
    johnTreasuresDesc: "성경의 보물과 흥미로운 사실",
    quickAccessChapters: "유명한 장으로 빠른 접근:",
    johnChapter1: "서문",
    johnChapter3: "거듭남",
    johnChapter14: "나는 길이다",
    johnChapter20: "부활",
    version: "버전",
    madeWithLove: "하나님의 영광을 위해 사랑으로 만들어짐",
    backToMenu: "메뉴로 돌아가기"
  },

  chapters: {
    "1": "창세기",
    "2": "출애굽기",
    "3": "예수 그리스도",
    "4": "십자가형/부활",
    "5": "초대 교회",
    "6": "바울의 선교",
    "7": "서신/요한계시록",
    "8": "보너스 레벨"
  },


  bible: {
    readerTitle: "📖 성경 리더",
    johnReaderTitle: "성경 리더 - 요한복음",
    john: "요한",
    loading: "성경을 로드하는 중...",
    loadingChapter: "요한복음 {chapter}장. 전체 데이터를 로드하는 중입니다...",
    exploreWhileLoading: "그동안 다른 장을 탐색하거나 검색 기능을 사용할 수 있습니다.",
    menu: "메뉴",
    tabBible: "성경",
    tabUnity: "통일",
    strong: "Strong",
    strongReferences: "Strong 참조",
    verses: "절",
    previous: "이전",
    next: "다음",
    strongDefinition: "Strong 참조",
    word: "원어",
    transliteration: "음역",
    pronunciation: "발음",
    meaning: "의미",
    definition: "완전한 정의",
    usage: "성경적 사용",
    etymology: "어원",
    close: "닫기",
    moreReferences: "및 {{count}}개의 다른 참조",
    copyright: "📖 Korean Revised Version - 공개 도메인 • Strong 번호 포함",
    shareVerse: "이 구절 공유",
    markAsRead: "구절 읽음",
    alreadyRead: "이미 읽음",
    readingBonus: "읽기 보너스",
    results: "결과",
    result: "결과",
    copy: "복사",
    image: "이미지"
  },

  philosophy: {
    title: "철학적 차원",
    loveOntology: "존재론적 원리로서의 사랑",
    loveDescription: "예수님은 사랑을 형이상학적 기초로 변화시킵니다: 하나님과 이웃을 사랑하는 것이 진정한 존재의 구조 자체가 됩니다. 사랑은 도덕을 초월하여 존재의 방식이 됩니다.",
    newCommandment: "새 계명",
    jesusEmphasizes: "예수님이 새 계명을 주실 때, 사랑한다는 동사를 강조합니다",
    loveGod: "마음을 다해 하나님을 사랑하라",
    loveNeighbor: "네 이웃을 네 자신같이 사랑하라",
    lovePriority: "사랑이 우선순위가 됩니다"
  },

  footer: {
    version: "버전 1.0 • 2024",
    dedication: "하나님의 영광을 위해 개발됨"
  },

  endCredits: {
    lines: [
      { text: "당신은 산 정상에 도달했습니다", delay: 2000 },
      { text: "많은 것을 배웠습니다", delay: 2000 },
      { text: "당신의 믿음은 매일 성장합니다", delay: 2000 },
      { text: "하나님과 함께 아름다운 일들을 경험합니다", delay: 2000 },
      { text: "어려움은 당신을 성장시킵니다", delay: 2000 },
      { text: "그것들은 무엇이 중요한지 보여줍니다", delay: 2000 },
      { text: "어린아이처럼 겸손하십시오", delay: 2000 },
      { text: "하나님은 당신의 단순한 마음을 사랑하십니다", delay: 2000 },
      { text: "고요함 속에서 당신은 하나님을 듣습니다", delay: 2000 },
      { text: "금식은 당신의 영을 자유롭게 합니다", delay: 2000 },
      { text: "기도하면 하나님이 인도하실 것입니다", delay: 2000 },
      { text: "교만은 진리를 숨깁니다", delay: 2000 },
      { text: "하나님의 은혜는 장엄합니다", delay: 2000 },
      { text: "그것은 하나님의 마음에서 나옵니다", delay: 2000 },
      { text: "진정한 믿음은 당신을 자유롭게 합니다", delay: 2000 },
      { text: "그것은 당신을 영원히 하나님과 결합시킵니다", delay: 2000 },
      { text: "사랑은 모든 것을 바꿀 수 있습니다", delay: 2000 },
      { text: "기적을 행할 수 있습니다", delay: 2000 },
      { text: "저와 함께 반복하세요", delay: 2000 },
      { text: "예수님, 제 마음을 드립니다", delay: 3000 },
      { text: "당신은 나의 왕, 나의 구원자입니다", delay: 3000 },
      { text: "와서 제 삶을 변화시켜 주세요", delay: 3000 },
      { text: "여정은 지금 계속됩니다", delay: 2000 },
      { text: "이 아름다운 빛을 나누십시오", delay: 2000 },
      { text: "결코 끝나지 않는 삶을 향하여", delay: 2000 },
      { text: "마음속에 사랑을 간직하십시오", delay: 3000 },
      { text: "귀중한 보물처럼", delay: 3000 }
    ],
    finalMessages: {
      congratulations: "축하합니다!",
      proud: "우리는 당신을 자랑스럽게 생각합니다",
      courage: "용감한 전사",
      peace: "평화의 전달자",
      child: "하나님의 자녀",
      blessing: "하나님이 당신을 축복하시기를",
      continue: "계속하기"
    }
  },

  mountain: {
    chapter: "챕터",
    chapterProgress: "챕터 {{current}}/{{total}}",
    secret: "비밀!",
    spiritualAscension: "영적 상승",
    levelProgress: "레벨 {{level}} • {{stars}} 별 획득",
    combo: "콤보",
    perfectMessage: '"내 생각은 너희 생각과 다르니라" - 어린 양이 완전한 지혜를 향해 오릅니다',
    goodMessage: '"구하라 그리하면 찾을 것이니" - 진리를 향한 상승이 계속됩니다',
    startMessage: '"믿음이 겨자씨 한 알만 하여도" - 빛을 향한 첫걸음',
    skipAnimation: "애니메이션 건너뛰기",
    stats: {
      points: "pts",
      level: "Niv."
    },
    waypoints: {
      start: "시작",
      firstSlope: "첫 번째 경사",
      lastSlope: "마지막 경사"
    },
    status: {
      victory: "승리!",
      defeat: "패배",
      inProgress: "진행 중"
    }
  },

  validation: {
    pseudoTooShort: "사용자 이름은 최소 2자 이상이어야 합니다",
    enterPseudo: "사용자 이름을 입력하세요"
  },

  pseudoSetup: {
    title: "사용자 이름 선택",
    confirm: "이름 확인"
  },

  navigation: {
    back: "뒤로"
  },

  console: {
    starsUnlocked: "별 달성! 챕터 잠금 해제",
    defeatAnimation: "패배... 예수 그리스도가 내려감"
  },

  errors: {
    progressionError: "진행 오류",
    invalidProgressionData: "유효하지 않은 진행 데이터:"
  },

  levels: {
    chaptersAndBonus: "8개 챕터 + 보너스 레벨",
    bonusUnlocked: "🏆 보너스 레벨 잠금 해제! 영적 완벽에 도달했습니다!",
    starsToDiscover: "발견할 {stars} 273개",
    starsPerLevel: "레벨당 {stars} 3개"
  },

  architecture: {
    title: "🔧 기술 아키텍처",
    react: {
      name: "React",
      description: "현대적 인터페이스"
    },
    modules: {
      name: "모듈",
      description: "동적 로딩"
    },
    localStorage: {
      name: "로컬스토리지",
      description: "로컬 저장"
    },
    tailwind: {
      name: "Tailwind",
      description: "반응형 디자인"
    }
  },

  gameManager: {
    title: "게임 저장",
    saveLocal: "로컬 저장",
    saveCloud: "클라우드 동기화",
    saveWaiting: "연결 대기 중",
    lastSave: "마지막 저장:",
    never: "없음",
    saving: "저장 중...",
    save: "저장",
    loadProgress: "불러오기",
    loading: "불러오는 중...",
    autoSaveEnabled: "💾 자동 저장 활성화됨",
    saveError: "❌ 저장 오류",
    gameSaved: "✅ 게임 저장 완료!",
    gameLoaded: "📥 게임 불러오기 완료!"
  },

  unity: unityTranslations
};

export default uiTranslations;
